








































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import QuestListsTable from './QuestListsTable.vue';

@Component({
    components: {
        QuestListsTable
    }
})
export default class FrequencyQuestTable extends Vue {
    frequencyQuestLists = [
        { id: 1, type: null, routin: 'DAILY_QUEST', actions: 'Daily Quest (User) ' },
        { id: 2, type: null, routin: 'WEEKLY_QUEST', actions: 'Weekly Quest (User)' },
        { id: 3, type: null, routin: 'LIFE_TIME_QUEST', actions: 'Lifetime/Achievements Quest (User)' },
        { id: 4, type: 'artist', routin: 'DAILY_QUEST', actions: 'Daily Quest (Artist)' },
        { id: 5, type: 'artist', routin: 'WEEKLY_QUEST', actions: 'Weekly Quest (Artist) ' },
        { id: 6, type: 'artist', routin: 'LIFE_TIME_QUEST', actions: 'Lifetime/Achievements Quest (Artist)' },
        { id: 7, type: 'industry', routin: 'DAILY_QUEST', actions: 'Daily Quest (Industry)' },
        { id: 8, type: 'industry', routin: 'WEEKLY_QUEST', actions: 'Weekly Quest (Industry)' },
        { id: 9, type: 'industry', routin: 'LIFE_TIME_QUEST', actions: 'Lifetime/Achievements Quest (Industry)' }
    ];
    headers = [
        {
            text: 'Actions',
            align: 'start',
            sortable: false,
            value: 'actions',
        },
        {
            text: '',
            align: 'end',
            value: 'data-table-expand'
        }
    ];
}
